import React, { useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { Modal } from '../../../components/Modal/Modal'

export interface UpdateSystemMeetingTemplateModalProps {
  show: boolean
  onConfirm: (newName?: string) => void
  onCancel: () => void
  meetingTemplateName: string
}
export const UpdateSystemMeetingTemplateModal: React.FC<UpdateSystemMeetingTemplateModalProps> = ({ show, onConfirm, onCancel, meetingTemplateName }) => {
  const [newMeetingTemplateName, setNewMeetingTemplateName] = useState<string>(meetingTemplateName)

  const body = (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Update System Meeting Type</h4>
        </Col>
      </Row>
      <Row className=''>
        <Col className='p-0'>
          <div className='paragraph-medium mb-3'>System meeting types cannot be changed. Would you like to create a new meeting type?</div>
          <div className='lead-small'>New Meeting Type Name</div>
          <Form.Control
            type='text'
            value={newMeetingTemplateName}
            onChange={(e) => setNewMeetingTemplateName(e.currentTarget.value)}
            placeholder='Enter a name…'
          />
        </Col>
      </Row>
    </Container>
  )
  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={<></>}
      body={body}
      showFooterActions={true}
      onFooterPrimaryAction={() => onConfirm(newMeetingTemplateName)}
      footerPrimaryActionTitle='Save as New Meeting Type'
      footerPrimaryActionButtonVariant='primary'
      footerPrimaryActionDisabled={!newMeetingTemplateName}
    />
  )
}
